import { Translator } from 'Translator';
import Popover from 'components/Popover';
import RadioButton from 'components/RadioButton';
import { AVAILABILITY_FILTER_OPTIONS } from 'data/subOptions/availabilitySubOptions';
import { formatISO } from 'date-fns';
import parseISO from 'date-fns/parseISO';
import PopoverFooter from 'modules/common/Popovers/PopoverFooter';
import { PopoverTriggerSource } from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import React from 'react';
import MultiDayDatePicker from 'reusable-components/controls/MultiDayDatePicker';

const CSS = require('./AgendaPopover.module.scss');

interface AgendaPopoverProps {
  onSelectDate: (date: Date) => void;
  onClickToday: () => void;
  onClickTomorrow: () => void;
  onApply: (source: PopoverTriggerSource) => (e: any) => void;
  onClear: (e: any) => void;
  startDate: Date;
  endDate: Date;
  showAvailabilityOptions: { show: boolean; showNow: boolean };
  noBackdrop?: boolean;
}

function AgendaPopover({
  startDate,
  endDate,
  onSelectDate,
  onApply,
  onClear,
  showAvailabilityOptions,
  noBackdrop,
  onClickToday,
  onClickTomorrow,
}: AgendaPopoverProps) {
  const onDateChange = (date: string) => onSelectDate(parseISO(date));
  const selectedStartDate = startDate
    ? formatISO(startDate, { representation: 'date' })
    : null;
  const selectedEndDate = endDate
    ? formatISO(endDate, { representation: 'date' })
    : startDate
      ? formatISO(startDate, { representation: 'date' })
      : null;

  return (
    <div className={CSS.PeoplePopover}>
      <Popover
        show
        name="agendaPopover"
        underNavbar
        noBackdrop={noBackdrop}
        className={CSS.Popover}
        onClose={onApply('escape button')}
        onOutSideClick={onApply('outside click')}
      >
        <div className={CSS.PopoverContent}>
          {showAvailabilityOptions.show && (
            <div className={CSS.FiltersContainer}>
              <h2 className={CSS.FiltersTitle}>
                {Translator.translate(
                  'Common.DatePicker.whenDoYouWantToGo',
                  {},
                  true,
                  'When do you want to go?',
                )}
              </h2>
              <div className={CSS.Filters}>
                <div className={CSS.Filter} onClick={onClickToday}>
                  <RadioButton
                    value={AVAILABILITY_FILTER_OPTIONS.TODAY}
                    name={'availability'}
                    className={CSS.FilterCheckbox}
                  />
                  <span className={CSS.FilterLabel}>
                    {Translator.translate(
                      'SearchPage.DateFilter.availabilityToday',
                      {},
                      true,
                      'Today',
                    )}
                  </span>
                </div>
                <div className={CSS.Filter} onClick={onClickTomorrow}>
                  <RadioButton
                    value={AVAILABILITY_FILTER_OPTIONS.TOMORROW}
                    name={'availability'}
                    className={CSS.FilterCheckbox}
                  />
                  <span className={CSS.FilterLabel}>
                    {Translator.translate(
                      'SearchPage.DateFilter.availabilityTomorrow',
                      {},
                      true,
                      'Tomorrow',
                    )}
                  </span>
                </div>
              </div>
              <div className={CSS.Separator}>
                {Translator.translate('Forms.Separator.or', {}, true, 'or')}
              </div>
            </div>
          )}
          <div className={CSS.Carousel}>
            <MultiDayDatePicker
              onDateChange={onDateChange}
              selectedStartDate={selectedStartDate}
              selectedEndDate={selectedEndDate}
              showTwoMonths
            />
          </div>
        </div>
        <div className={CSS.StickyContainer}>
          <PopoverFooter onClear={onClear} onApply={onApply('apply button')} />
        </div>
      </Popover>
    </div>
  );
}

export default AgendaPopover;
